import React from 'react'
import { CallbackComponent } from 'redux-oidc'
import userManager from './userManager'

function safeRedirectPath(path) {
  if (!path) return '/'
  if (path.startsWith('/') && !path.startsWith('//')) return path
  return '/'
}

const Callback = () => (
  <CallbackComponent
    userManager={userManager}
    successCallback={(success) => {
      localStorage.setItem('access_token', success.access_token)
      const { state } = success
      const returnTo = state ? state.returnTo : null
      // Full page reload navigates to the tenant-prefixed URL correctly
      window.location.href = safeRedirectPath(returnTo)
      }
  }
    errorCallback={(error) => {
        console.log('Catch fetch error: ', error)
        window.location.href = '/'
      }
    }
  >
    <div>Redirecting...</div>
  </CallbackComponent>
)

export default Callback



// WEBPACK FOOTER //
// ./src/containers/login/Callback.jsx